import React from 'react';
import { Body5, Container } from '@ui';
import styled from 'styled-components';
import { ResultContext } from '@/contexts/ResultContext';
import { formatContext, parseContextValue } from '@utils/result';
import { CollapseButton } from '@ui/buttons/CollapseButton';

const ContextWrapper = styled.div``;
const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  cursor: pointer;
`;
const Label = styled.div`
  padding-bottom: 8px;
`;

const ContextRow = ({ value, isUsingFullContext }) => {
  const { filename, chunkIndex, text } = parseContextValue(value);

  if (isUsingFullContext) {
    return (
      <p>
        <Container>
          <Body5 bold>{filename}</Body5>
          <Body5 isLowContrast> {chunkIndex}</Body5>
        </Container>

        <Container top={8} left={8}>
          <Body5>{text}</Body5>
        </Container>
      </p>
    );
  }

  return (
    <p>
      <Body5>{value}</Body5>
    </p>
  );
};

export const ContextSources = ({ top = 0 }) => {
  const { context } = React.useContext(ResultContext);

  const [contextValue, setContextValue] = React.useState(null);
  const [isCollapsed, setIsCollapsed] = React.useState(true);

  // TODO: add citations context
  const isShowingCitations = false;

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  React.useEffect(() => {
    const formatted = formatContext(context);
    setContextValue(formatted || null);
  }, [context]);

  if (!contextValue) return null;

  return (
    <ContextWrapper>
      <Container row alignRight top={top}>
        <ButtonWrapper onClick={toggleCollapse}>
          <Container right={4} bottom={4}>
            <Label>
              <Body5 bold>Sources</Body5>
            </Label>
          </Container>
          <CollapseButton isCollapsed={isCollapsed} setCollapsed={setIsCollapsed} />
        </ButtonWrapper>
      </Container>
      {isCollapsed ? null : (
        <Container>
          {contextValue?.map((line, i) => (
            <ContextRow key={i} value={line} isUsingFullContext={false && isShowingCitations} />
          ))}
        </Container>
      )}
    </ContextWrapper>
  );
};
